/**
 * The OmniCloud wordmark, as used on every unauthenticated page.
 *
 * It exists so the four auth pages cannot drift apart again: they previously
 * rendered the same asset at 206x58 (login, register — inline JSX) and 44x12
 * (forgot, reset — the plain string form, sized into Ant Design Pro's fixed
 * 44px logo slot), which made the wordmark illegible on half the flow.
 * Sizing lives in `index.css` next to the slot override it depends on.
 */
export function BrandLogo() {
  return <img src="/omnitech-logo.png" alt="OmniCloud" className="brand-logo" />;
}

export default BrandLogo;
